import React from 'react';
import ClientPaymentLinksPositionById from './ClientPaymentLinksPositionById';
import ProfileLayout from '../../../layout/profile';

export default function PaymentLinksPosition () {
    return (
        <ProfileLayout>
            <ClientPaymentLinksPositionById />
        </ProfileLayout>
    );
}
